<template>
  <div class="container_view">
    <v-card class="content_card" elevation="10" variant="flat">
      <div>
        <header>
          <v-card-title> Avisos </v-card-title>
          <v-divider class="mx-3"></v-divider>
        </header>
      </div>
      <div class="content_accion">
        <div>
          <v-text-field
            v-model="search"
            label="Búsqueda"
            prepend-inner-icon="mdi-magnify"
            single-line
            variant="outlined"
            hide-details
            class="filter"
          ></v-text-field>
        </div>
        <div>
          <v-select
            class="select"
            density="compact"
            :items="listUsuarios"
            item-title="usuario"
            item-value="id"
            v-model="selectUser"
            label="Selecione un usuario"
          ></v-select>
          <v-btn
            v-bind="props"
            class="text-none mb-4 buscar"
            prepend-icon="mdi-magnify"
            color="indigo-darken-3"
            @click="getAvisosEquipoSup()"
          >
            Buscar
          </v-btn>
          <v-btn
            icon="mdi-reload"
            size="small"
            variant="outlined"
            color="indigo-darken-3"
            class="mr-2"
            @click="getAvisosAsignados()"
          >
          </v-btn>
        </div>
      </div>
      <div class="container_table">
        <v-data-table
          :headers="headersAvisosAsignados"
          fixed-header
          :items="listAvisosAsignados"
          :search="search"
          :loading="loadingAvisosAsignados"
        >
        </v-data-table>
      </div>
    </v-card>
    <AlertComponent :value="dialogData" />
    <SnackbarComponent :value="snackbarData" />
  </div>
</template>

<script>
import { NoticeService } from "@/services/NoticesService";
import AlertComponent from "@/components/Alert.vue";
import SnackbarComponent from "@/components/Snackbar.vue";

export default {
  name: "NoticeSupervisorComponent",
  components: {
    AlertComponent,
    SnackbarComponent,
  },
  data() {
    return {
      listAvisosAsignados: [],
      loadingAvisosAsignados: true,
      headersAvisosAsignados: [
        { title: "Título", key: "titulo" },
        { title: "Descripción", key: "descripcion" },
        { title: "Autor", key: "autor" },
      ],
      dialogData: {
        openDialog: false,
        title: "",
        description: "",
        icon: "",
      },
      snackbarData: {
        openSnackbar: false,
        description: "",
      },
      listUsuarios: [],
      selectUser: null,
      search: "",
    };
  },
  beforeMount() {
    this.getAvisosAsignados();
    this.getUserBySupervisor();
  },
  methods: {
    getAvisosAsignados: async function () {
      let idU = await NoticeService.encriptar(localStorage.getItem("ID"));
      this.loadingAvisosAsignados = true;
      await NoticeService.getNoticesByUser(idU.msg)
        .then((resp) => {
          if (!resp.error) {
            this.listAvisosAsignados = resp.response;
            setTimeout(() => {
              this.loadingAvisosAsignados = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
      this.selectUser = null;
    },
    getUserBySupervisor: async function () {
      let idU = await NoticeService.encriptar(localStorage.getItem("ID"));

      await NoticeService.getUsersBySupervisor(idU.msg)
        .then((resp) => {
          if (!resp.error) {
            this.listUsuarios = resp.response;
            setTimeout(() => {
              this.loadingAvisosAsignados = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
    },
    getAvisosEquipoSup: async function () {
      let idU = await NoticeService.encriptar(this.selectUser);
      this.loadingAvisosAsignados = true;
      await NoticeService.getNoticesByUser(idU.msg)
        .then((resp) => {
          if (!resp.error) {
            this.listAvisosAsignados = resp.response;
            setTimeout(() => {
              this.loadingAvisosAsignados = false;
            }, 1000);
          } else {
            this.dialogData = {
              openDialog: true,
              title: "Ocurrió un Problema",
              description: resp.msg,
            };
          }
        })
        .catch((err) => {
          this.dialogData = {
            openDialog: true,
            title: "Ocurrió un Problema",
            description: err,
          };
        });
    },
  },
};
</script>

<style scoped>
.filter {
  width: 300px;
}

.content_table {
  overflow: auto;
}

.content_accion {
  padding-bottom: 10px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

.content_load {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.select {
  float: left;
  margin-right: 2vh;
  width: 60vh;
}

.buscar {
  float: left;
  margin-right: 2vh;
  width: 20vh;
}
</style>
